import React from "react";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import FormLabel from "@mui/material/FormLabel";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Grid, Link } from "@mui/material";
import { Controller } from "react-hook-form";
import WelcomeTitle from "../common/WelcomeTitle";
import { useStyles } from "../login/Login.page.style";

const LoginComponent = (props) => {
	const {
		register,
		handleSubmit,
		onSubmit,
		control,
		errors,
		handleClickShowPassword,
		handleMouseDownPassword,
		showPassword,
		showConfirmPassword,
		handleClickShowConfirmPassword,
	} = props;
	const classes = useStyles();

	return (
		<form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
			<Grid container direction={"column"} className={classes.loginFormContainer}>
				<WelcomeTitle />
				<Grid item container direction={"column"} className={classes.loginInputBox}>
					<Grid item className={classes.loginFont}>
						RESET PASSWORD
					</Grid>
					<Grid item className={classes.LoginInputWrapper}>
						<FormControl fullWidth>
							<FormLabel htmlFor="email" className={classes.blackColor}>
								Email
							</FormLabel>
							<Controller
								render={({ field }) => (
									<TextField
										{...field}
										{...register("email")}
										error={!!errors?.email}
										helperText={errors?.email?.message}
										variant="standard"
										InputProps={{
											className: classes.inputStyle,
										}}
										inputProps={{ maxLength: 128 }}
										disabled
									/>
								)}
								id={"email"}
								name="email"
								control={control}
								rules={{
									required: true,
								}}
							/>
						</FormControl>
					</Grid>
					<Grid item className={classes.loginPwdInputWrapper}>
						<FormControl fullWidth>
							<FormLabel htmlFor="password" className={classes.blackColor}>
								New Password
							</FormLabel>
							<Controller
								render={({ field }) => (
									<TextField
										{...field}
										type={showPassword ? "text" : "password"}
										error={!!errors.pwd}
										helperText={errors.pwd?.message}
										style={{ height: "30px" }}
										variant="standard"
										InputProps={{
											className: classes.inputStyle,
											endAdornment: (
												<InputAdornment position="end">
													<IconButton
														aria-label="toggle password visibility"
														onClick={handleClickShowPassword}
														onMouseDown={handleMouseDownPassword}
														style={{ color: "black" }}
														size="large"
													>
														{showPassword ? <Visibility /> : <VisibilityOff />}
													</IconButton>
												</InputAdornment>
											),
										}}
										inputProps={{
											maxLength: 48,
											style: {
												fontFamily: showPassword || "text-security-disc",
											},
										}}
									/>
								)}
								control={control}
								rules={{
									required: true,
								}}
								id="pwd"
								name="pwd"
							/>
						</FormControl>
					</Grid>
					<Grid item className={classes.loginPwdInputWrapper}>
						<FormControl fullWidth>
							<FormLabel htmlFor="confirmPassword" className={classes.blackColor}>
								Confirm New Password
							</FormLabel>
							<Controller
								render={({ field }) => (
									<TextField
										{...field}
										type={showConfirmPassword ? "text" : "password"}
										error={!!errors.confirmPassword}
										helperText={errors.confirmPassword?.message}
										style={{ height: "30px" }}
										variant="standard"
										InputProps={{
											className: classes.inputStyle,
											endAdornment: (
												<InputAdornment position="end">
													<IconButton
														aria-label="toggle confirm Password visibility"
														onClick={handleClickShowConfirmPassword}
														onMouseDown={handleMouseDownPassword}
														style={{ color: "black" }}
														size="large"
													>
														{showConfirmPassword ? <Visibility /> : <VisibilityOff />}
													</IconButton>
												</InputAdornment>
											),
										}}
										inputProps={{
											maxLength: 48,
											style: {
												fontFamily: showConfirmPassword || "text-security-disc",
											},
										}}
									/>
								)}
								control={control}
								// rules={{
								// 	required: true,

								// }}
								id="confirmPassword"
								name="confirmPassword"
							/>
						</FormControl>
					</Grid>
					<Grid item className={classes.LoginBtnWrapper}>
						<FormControl>
							<Button
								type="submit"
								variant="contained"
								color="primary"
								style={{
									textTransform: "none",
									fontFamily: "Quicksand-SemiBold",
									fontSize: 16,
								}}
							>
								Reset
							</Button>
						</FormControl>
					</Grid>
				</Grid>
				<Grid item container className={classes.signupNow}>
					<Link href={"/login"} className={classes.signupLink}>
						Back to login
					</Link>
				</Grid>
			</Grid>
		</form>
	);
};

export default LoginComponent;
